import { render, staticRenderFns } from "./LmsFilesFromControlPoint.vue?vue&type=template&id=b84bb5ba&scoped=true&"
import script from "./LmsFilesFromControlPoint.vue?vue&type=script&lang=js&"
export * from "./LmsFilesFromControlPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84bb5ba",
  null
  
)

export default component.exports